const USER_ACCESS_LIST_ROUTE_STATE_KEY = 'userAccessList';

export type UserAccessListState = {
  searchText: string;
  scrollTop: number;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function getDefaultUserAccessListState(): UserAccessListState {
  return { searchText: '', scrollTop: 0 };
}

export function getUserAccessListState(locationState: unknown): UserAccessListState {
  const defaultState = getDefaultUserAccessListState();
  if (!isRecord(locationState) || !isRecord(locationState[USER_ACCESS_LIST_ROUTE_STATE_KEY])) {
    return defaultState;
  }

  const listState = locationState[USER_ACCESS_LIST_ROUTE_STATE_KEY];
  const scrollTop = listState.scrollTop;

  return {
    searchText: typeof listState.searchText === 'string' ? listState.searchText : defaultState.searchText,
    scrollTop:
      typeof scrollTop === 'number' && Number.isFinite(scrollTop) ? Math.max(scrollTop, 0) : defaultState.scrollTop,
  };
}

export function createUserAccessListRouteState(state: UserAccessListState) {
  return {
    [USER_ACCESS_LIST_ROUTE_STATE_KEY]: {
      searchText: state.searchText,
      scrollTop: state.scrollTop,
    },
  };
}
